/* vim:set expandtab ff=unix fenc=utf-8 ts=4 */
/*! migrate-mute.js */
/* global window */

window.jQuery.migrateMute = true

/*
 * Local Variables:
 * coding: utf-8-unix
 * indent-tabs-mode: nil
 * tab-width: 4
 * End:
 */
